/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Settings_IntroInputs */

const en_us2_clubs_settings_intro = /** @type {(inputs: Clubs_Settings_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A change applies at once for everyone, without another notice. Members who disagree may leave the club.`)
};

const pt_br2_clubs_settings_intro = /** @type {(inputs: Clubs_Settings_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma mudança vale na hora para todos, sem novo aviso. Quem não concordar pode sair do clube.`)
};

const es_419_clubs_settings_intro = /** @type {(inputs: Clubs_Settings_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un cambio se aplica al instante para todos, sin otro aviso. Los miembros que no estén de acuerdo pueden salir del club.`)
};

const pt_pt2_clubs_settings_intro = /** @type {(inputs: Clubs_Settings_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma alteração aplica-se logo a todos, sem novo aviso. Quem não concordar pode sair do clube.`)
};

const fr_fr2_clubs_settings_intro = /** @type {(inputs: Clubs_Settings_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un changement s'applique tout de suite pour tous, sans nouvel avis. Les membres en désaccord peuvent quitter le club.`)
};

const de_de2_clubs_settings_intro = /** @type {(inputs: Clubs_Settings_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Änderung gilt sofort für alle, ohne erneuten Hinweis. Wer nicht einverstanden ist, kann den Club verlassen.`)
};

const it_it2_clubs_settings_intro = /** @type {(inputs: Clubs_Settings_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una modifica vale subito per tutti, senza altro avviso. I membri in disaccordo possono lasciare il club.`)
};

/**
* | output |
* | --- |
* | "A change applies at once for everyone, without another notice. Members who disagree may leave the club." |
*
* @param {Clubs_Settings_IntroInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_settings_intro = /** @type {((inputs?: Clubs_Settings_IntroInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Settings_IntroInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_settings_intro(inputs)
	if (locale === "es-419") return es_419_clubs_settings_intro(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_settings_intro(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_settings_intro(inputs)
	if (locale === "de-DE") return de_de2_clubs_settings_intro(inputs)
	if (locale === "it-IT") return it_it2_clubs_settings_intro(inputs)
	return en_us2_clubs_settings_intro(inputs)
});
export { clubs_settings_intro as "clubs.settings_intro" }